import { useState } from 'react'
import { Sidebar as RaSidebar, useSidebarState } from 'react-admin'

export const Sidebar = (props: any) => {
  const [open, setOpen] = useSidebarState()
  const [wasOpenBeforeHover, setWasOpenBeforeHover] = useState(false)

  const handleMouseEnter = () => {
    if (!open) {
      setWasOpenBeforeHover(false)
      setOpen(true)
    } else {
      setWasOpenBeforeHover(true)
    }
  }

  const handleMouseLeave = () => {
    if (!wasOpenBeforeHover) {
      setOpen(false)
    }
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ height: '100%' }}>
      <RaSidebar {...props} />
    </div>
  )
}
